import styled, { css } from 'styled-components';

interface ButtonSelectProps {
  selected?: boolean;
}

export const Container = styled.div`
  display: flex;
  height: 100%;
  padding: 45px;
`;

export const Grouper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  &:last-child {
    justify-content: center;
  }

  > h1 {
    color: ${(props) => props.theme.colors.graySecondary};
    font-size: 26px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
    margin-top: 25px;
  }

  > p {
    color: ${(props) => props.theme.colors.grayAlternative};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;
    padding: 25px 0 0 0;
  }

  > img {
    align-items: center;
    margin-left: 80px;
    max-width: 190px;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 45px;
  width: 100%;
`;

export const ButtonSelect = styled.button<ButtonSelectProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.selected ? '#5AB1E3' : '#f8f8f8')};
  border: none;
  border-radius: 15px;
  color: ${(props) => (props.selected ? props.theme.colors.white : '#707683')};
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  margin: 5px 0;
  min-height: 85px;
  min-width: 105px;
  text-align: center;
  transition: background-color 0.4s;

  > div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 17px;
    margin-bottom: 5px;

    > img {
      width: 21px;
    }
  }

  & + button {
    margin-left: 15px;
  }

  &:hover {
    background: ${(props) => !props.selected && !props.disabled && '#f5f5f5'};
  }

  ${(props) =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;
